import { render, staticRenderFns } from "./attribute.vue?vue&type=template&id=6ebd7ff4&scoped=true&"
import script from "./attribute.vue?vue&type=script&lang=js&"
export * from "./attribute.vue?vue&type=script&lang=js&"
import style0 from "./attribute.vue?vue&type=style&index=0&id=6ebd7ff4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebd7ff4",
  null
  
)

export default component.exports